const AcademicDetails = ({
  formData,
  onNumChange,
  onClick
}: {
  formData: any;
  onNumChange: (e: any, semKey?: string) => void;
  onClick: (e: any) => void;
}) => {
  return (
    <div>
      <div className='flex flex-row gap-3'>
        <div className='w-full'>
          <label
            htmlFor='collegeRollNo'
            className='flex items-center gap-2 text-sm font-medium'
          >
            10th Percentage
          </label>
          <input
            type='number'
            id='tenthPercentage'
            name='tenthPercentage'
            placeholder={'10th Percentage'}
            className='border-input bg-background w-full rounded-lg border px-4 py-3 transition-all focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20'
            onChange={e => {
              onNumChange(e, '');
            }}
            value={formData?.academicDetails?.tenthPercentage}
            min={0}
          />
        </div>
        <div className='w-full'>
          <label
            htmlFor='collegeRollNo'
            className='flex items-center gap-2 text-sm font-medium'
          >
            Inter Percentage
          </label>
          <input
            type='number'
            id='interPercentage'
            name='interPercentage'
            placeholder={'Inter Percentage'}
            className='border-input bg-background w-full rounded-lg border px-4 py-3 transition-all focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20'
            onChange={e => {
              onNumChange(e);
            }}
            value={formData?.academicDetails?.interPercentage}
            min={0}
          />
        </div>
      </div>
      <div>
        <div className='mt-4'>
          <p>
            BTech Semester Scores{' '}
            <button
              type='button'
              name='addSemister'
              disabled={
                formData?.academicDetails?.bTechSemsPercentage &&
                Object.keys(formData.academicDetails.bTechSemsPercentage)
                  .length >= 10
              }
              className='ml-2 rounded bg-primary px-2 py-1 text-sm text-white disabled:cursor-not-allowed disabled:bg-gray-400'
              onClick={() => {
                onClick('addSemister');
              }}
            >
              Add Semister
            </button>
            <button
              type='button'
              name='removeSemister'
              disabled={
                !formData?.academicDetails?.bTechSemsPercentage ||
                Object.keys(formData.academicDetails.bTechSemsPercentage)
                  .length === 0
              }
              className='ml-2 rounded bg-red-600 px-2 py-1 text-sm text-white disabled:cursor-not-allowed disabled:bg-gray-400'
              onClick={() => {
                onClick('removeSemister');
              }}
            >
              Remove Semister
            </button>
          </p>
        </div>
        <div className='grid grid-cols-2 gap-3'>
          {formData?.academicDetails?.bTechSemsPercentage &&
            Object.keys(formData.academicDetails.bTechSemsPercentage).map(
              semKey => (
                <div key={semKey} className='mt-2'>
                  <label htmlFor={semKey} className='block text-sm font-medium'>
                    {semKey}
                  </label>
                  <input
                    type='number'
                    id={semKey}
                    min={0}
                    max={100}
                    name={semKey}
                    placeholder={`Enter ${semKey} percentage`}
                    className='border-input bg-background w-full rounded-lg border px-4 py-3 transition-all focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20'
                    onChange={e => {
                      onNumChange(e, semKey);
                    }}
                    value={
                      formData?.academicDetails?.bTechSemsPercentage?.[semKey]
                    }
                  />
                </div>
              )
            )}
        </div>
      </div>
    </div>
  );
};

export default AcademicDetails;
